// **  Initial State
const initialState = {};

const intlRef = (state = initialState, action) => {
  switch (action.type) {
    case "INTL":
      return action.data;
    default:
      return state;
  }
};

export default intlRef;
